<template>
  <b-card class="document-validation-card">
    <div class="mb-1">
      <h4 class="mb-0">
        {{ title }}
      </h4>
      <small class="text-body d-block mb-1">{{ subtitle }}</small>
      <b-form-checkbox
        :checked="value.enabled"
        switch
        :disabled="disabled"
        @change="update('enabled', $event)"
      >
        <span class="font-medium-1">
          Validação de {{ title }} <strong>{{ value.enabled ? 'Ativada' : 'Desativada' }}</strong>
        </span>
      </b-form-checkbox>
    </div>

    <div :class="{ 'document-validation-card__content--dimmed': !value.enabled }">
      <h6 class="mt-1">
        Ordem dos provedores
      </h6>
      <small class="text-body d-block mb-1">
        Arraste para definir a ordem de consulta. Se o primeiro estiver indisponível, o próximo é consultado.
      </small>
      <draggable
        :value="value.provider_order"
        :disabled="isLocked"
        class="list-group"
        tag="ul"
        :animation="200"
        ghost-class="moving-card"
        handle=".drag-handle"
        @input="update('provider_order', $event)"
      >
        <b-list-group-item
          v-for="(providerKey, index) in value.provider_order"
          :key="providerKey"
          tag="li"
          class="d-flex align-items-center"
        >
          <feather-icon
            icon="MenuIcon"
            size="18"
            class="drag-handle mr-1"
            :class="{ 'cursor-move': !isLocked }"
          />
          <b-avatar
            :text="`${index + 1}`"
            variant="light-primary"
            size="sm"
            class="mr-1"
          />
          <span class="flex-grow-1">{{ providerName(providerKey) }}</span>
          <b-form-checkbox
            :checked="true"
            switch
            :disabled="isLocked || value.provider_order.length === 1"
            :title="value.provider_order.length === 1 ? 'É necessário manter ao menos um provedor ativo' : 'Desativar provedor'"
            @change="disableProvider(providerKey)"
          />
        </b-list-group-item>
      </draggable>

      <ul
        v-if="inactiveProviders.length"
        class="list-group mt-50"
      >
        <b-list-group-item
          v-for="providerKey in inactiveProviders"
          :key="providerKey"
          tag="li"
          class="d-flex align-items-center provider-inactive"
        >
          <span class="flex-grow-1">
            {{ providerName(providerKey) }}
            <small class="text-body ml-50">(desativado)</small>
          </span>
          <b-form-checkbox
            :checked="false"
            switch
            :disabled="isLocked"
            title="Ativar provedor"
            @change="enableProvider(providerKey)"
          />
        </b-list-group-item>
      </ul>

      <h6 class="mt-2">
        Quando todos os provedores estiverem indisponíveis
      </h6>
      <b-form-radio-group
        :checked="value.on_unavailable"
        :options="unavailableBehaviorOptions"
        :name="`${title}-unavailable-behavior`"
        :disabled="isLocked"
        stacked
        @change="update('on_unavailable', $event)"
      />
    </div>
  </b-card>
</template>

<script>
import draggable from 'vuedraggable'
import {
  BCard, BFormCheckbox, BListGroupItem, BAvatar, BFormRadioGroup,
} from 'bootstrap-vue'

// Chaves de ProviderKey no backend (DocumentValidation/Support/ProviderKey.php)
const PROVIDER_NAMES = {
  serpro: 'Serpro (Receita Federal)',
  cpfcnpj: 'CPF/CNPJ (cpfcnpj.com.br)',
}

export default {
  components: {
    draggable,
    BCard,
    BFormCheckbox,
    BListGroupItem,
    BAvatar,
    BFormRadioGroup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    // { enabled, provider_order: ['cpfcnpj', 'serpro'], on_unavailable: 'fail' | 'manual_review' }
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unavailableBehaviorOptions: [
        { text: 'Bloquear cadastro', value: 'fail' },
        { text: 'Enviar para Revisão Manual', value: 'manual_review' },
      ],
    }
  },
  computed: {
    isLocked() {
      return this.disabled || !this.value.enabled
    },
    // Provedor fora de provider_order não é consultado pelo backend: é assim que ele fica desativado
    inactiveProviders() {
      return Object.keys(PROVIDER_NAMES).filter(key => !this.value.provider_order.includes(key))
    },
  },
  methods: {
    providerName(key) {
      return PROVIDER_NAMES[key] || key
    },
    disableProvider(key) {
      this.update('provider_order', this.value.provider_order.filter(k => k !== key))
    },
    enableProvider(key) {
      this.update('provider_order', [...this.value.provider_order, key])
    },
    update(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
  },
}
</script>

<style scoped>
.document-validation-card__content--dimmed {
  opacity: 0.5;
  pointer-events: none;
  user-select: none;
}
.provider-inactive {
  opacity: 0.6;
}
.moving-card {
  opacity: 0.5;
  background: #F7FAFC;
  border: 1px solid #7367f0;
}
</style>
